// office_port/documents: ссылки My Space на документы старого Office (/dict/report/..., /dict/document/..., /integration/...).
// Бэкенд (/office_port/documents/office-links/) говорит, включён ли OFFICE_PORT_DOCUMENTS, какие действия Office
// переключены на генерацию в My Space и смонтированы ли адреса integration_* (OFFICE_PORT_INTEGRATIONS).
// Выключено (или запрос не удался) — ссылка ведёт в Office, как раньше: FILE_URL + адрес Office (getFullUrl).
import { reactive } from "vue";
import instance from "@/services/api";
import { getFullUrl } from "@/services";
import { downloadOfficeDocument } from "./download";

// reactive — чтобы :href в шаблонах пересчитались, когда настройки загрузятся
const state = reactive({ loaded: false, documents_on: false, integrations_on: false, switched: [] });
let pending = null;

export const loadOfficeLinks = () => {
  if (state.loaded) return Promise.resolve(state);
  if (!pending) {
    pending = instance(true, null, { showToast: false })
      .get("/office_port/documents/office-links/")
      .then((r) => {
        Object.assign(state, r?.data?.data || {}, { loaded: true });
        return state;
      })
      .catch(() => state)
      .finally(() => {
        pending = null;
      });
  }
  return pending;
};

// '/dict/report/mode/act/...' → 'dict/report'
const actionOf = (officeUrl) => {
  const parts = String(officeUrl || "").split("?")[0].split("/").filter(Boolean);
  return parts.length >= 2 ? `${parts[0]}/${parts[1]}` : null;
};

export const officeDocumentsOn = () => !!state.documents_on;

export const isOfficeDocumentSwitched = (officeUrl) =>
  !!(state.documents_on && (state.switched || []).includes(actionOf(officeUrl)));

// Открыть документ Office: переключён — генерация My Space (скачивание с токеном); иначе — новая вкладка Office, как раньше.
export const openOfficeDocument = async (officeUrl, fallbackName) => {
  let win = null;
  if (!state.loaded) {
    // окно открываем сразу по клику (после запроса браузер заблокирует всплывающее окно), адрес подставляем потом
    win = window.open("", "_blank");
    await loadOfficeLinks();
  }
  if (isOfficeDocumentSwitched(officeUrl)) {
    win?.close();
    return downloadOfficeDocument(officeUrl, fallbackName);
  }
  if (win) win.location.href = getFullUrl(officeUrl);
  else window.open(getFullUrl(officeUrl), "_blank");
  return true;
};

// Ссылка для клиента «ДС для подписи» (Office integration/download-ds — без входа, по uuid): при включённых
// OFFICE_PORT_DOCUMENTS и OFFICE_PORT_INTEGRATIONS — перенесённое действие My Space
// (/office_port/integration_ext/integration/download-ds/...), иначе — Office, как раньше.
export const officeIntegrationHref = (officeUrl) => {
  if (state.documents_on && state.integrations_on) {
    return getFullUrl(`/office_port/integration_ext${officeUrl.startsWith("/") ? "" : "/"}${officeUrl}`, true);
  }
  return getFullUrl(officeUrl);
};
